export interface RegistrationPartner {
  id: string
  referralCodes: readonly string[]
  heading: string
  subheading: string
  logoSrc: string
  logoAlt: string
  imageSrc: string
}

const REGISTRATION_PARTNERS: readonly RegistrationPartner[] = [
  {
    id: 'restoration1',
    referralCodes: ['restoration1hq'],
    heading: 'The official payments platform for Restoration 1',
    subheading:
      'Get started in minutes. You don’t need to connect a bank or accounting system until you’re ready.',
    logoSrc: '/images/partners/restoration1-lockup.png',
    logoAlt: 'Nickel × Restoration 1',
    imageSrc: '/images/partners/restoration1.jpg',
  },
]

export function getRegistrationPartner(
  searchParams: URLSearchParams,
): RegistrationPartner | null {
  const code = searchParams.get('r')?.toLowerCase()
  if (!code) return null
  return (
    REGISTRATION_PARTNERS.find((partner) =>
      partner.referralCodes.includes(code),
    ) ?? null
  )
}
